import * as rudderanalytics from 'rudder-sdk-js';

import config from '../config';

rudderanalytics.load(config.rudderstack.writeKey, config.rudderstack.dataPlaneUrl);

enum RudderEvent {
  AccountExists = 'Account Exists',
  AccordionView = 'Accordion View',
  AutoCheckLowMilage = 'AutoCheck Low Milage',
  DocumentsImagesUploadedFromDevice = 'Documents Images Uploaded From Device',
  DocumentsImagesTextedIn = 'Documents Images Texted In',
  DocumentsImagesTextedInReceived = 'Documents Images Texted In Received',
  DoubleTaxModalShown = 'Double Tax Modal Shown (names must match modal)',
  Error = 'Error',
  FlowEntry = 'Flow Entry',
  FinishedDocumentsPage = 'Finished Documents Page',
  LicensePlateProvided = 'License Plate Provided',
  OtherLienholderModalOpen = 'Other Lienholder Modal Open',
  OtherLienholderSelected = 'Other Lienholder Selected',
  PackageDetailsModalOpen = 'Package Details Modal Open',
  PaymentCalculatorModalOpen = 'Payment Calculator Modal Open',
  PayoffAutomaticallyRetrieved = 'Payoff Automatically Retrieved',
  PayoffAutomaticallyRetrieveFailure = 'Payoff Automatically Retrieve Failure',
  PayoffIncludesSalesTax = 'Payoff Includes Sales Tax',
  VideoReviewCompleted = 'Video Review Completed',
  VideoReviewStarted = 'Video Review Started',
  VinProvided = 'Vin Provided',

  // Signing Events
  SigningExperienceOpened = 'Signing Experience Opened',
  StartedSigning = 'Started Signing',
  FinishedSigning = 'Finished Signing',
  LabTest = 'LabTest',
  LabTestSuccess = 'LabTestSuccess',
}

export { rudderanalytics, RudderEvent };
